const disclaimerData = [
  {
    id: 1,
    title: "Purpose of This Review",
    desc: "The information displayed in this Review Center—including policy values, beneficiary designations, ownership details, and other related data—is provided to facilitate ongoing plan management and strategic discussions. This information is based on the most recent data available to the platform through advisor input, carrier feeds, or document uploads. However, it may not represent the official or most current records maintained by the issuing insurance company.",
  },
  {
    id: 2,
    title: "Limitations of Data Accuracy",
    desc: "Insurance policies are complex and subject to change. Beneficiary designations, ownership structures, and policy values such as death benefit, cash value, premium payments, and loan balances may fluctuate or be updated by the carrier without immediate reflection here. While we strive for accuracy and timely updates, data feeds from carriers may experience delays, limitations, or omissions. As such, this review is for illustrative and planning purposes only.",
  },
  {
    id: 3,
    title: "Advisor and Client Responsibility",
    desc: "Neither IAPP nor your advisor guarantees the accuracy, completeness, or currency of the information presented in this review. Clients and advisors are strongly advised to confirm all key policy details—especially ownership, beneficiary designations, and in-force values—directly with the issuing insurance company before making any decisions, adjustments, or relying on the information for legal, tax, or financial planning.",
  },
  {
    id: 4,
    title: "Not a Legal or Binding Summary",
    desc: "This Review Center is not a legal or contractual summary of your policy and should not be considered a substitute for direct carrier correspondence or official documentation. It is intended to support informed dialogue and ongoing engagement with your advisor.",
  },
  {
    id: 5,
    title: "Acknowledgment of Use",
    desc: "By using this platform to review policy data, you acknowledge that this review is a working document subject to verification and that final confirmation of policy information must be obtained directly from the insurance carrier.",
  },
];
function Disclaimer() {
  return (
    <div className="p-4 rounded-xl border-[1px] border-solid border-[#EBEBEF]">
      <div className="text-md text-[#55556D] font-semibold mb-3 conthrax-font">Disclaimer</div>
      <div className="flex flex-col gap-3">
        {disclaimerData.map((points) => (
          <div className="flex flex-col gap-2">
            <span className="conthrax-font text-[#00132E] text-[16px] font-semibold">
              {points.title}
            </span>
            <span className="text-[16px] text-[#6C757D]">{points.desc}</span>
          </div>
        ))}
      </div>
      <div className="p-4 rounded-xl bg-[#F7F8F9] text-[#556376] mt-3">
        INVESTMENT AND INSURANCE PRODUCTS ARE: • NOT FDIC INSURED • NOT INSURED BY ANY FEDERAL
        GOVERNMENT AGENCY • NOT A DEPOSIT OR OTHER OBLIGATION OF, OR GUARANTEED BY, INSURANCE
        ADVANCED PLANNING PLATFORM, LLC OR ANY OF ITS AFFILIATES • SUBJECT TO INVESTMENT RISKS,
        INCLUDING POSSIBLE LOSS OF THE PRINCIPAL AMOUNT INVESTED
      </div>
    </div>
  );
}
export default Disclaimer;
